import { useQuery } from '@hooks/reactQuery';

import { getCCMavenirDates } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { parseStringDate } from '@utils/date';

import { TMavenirDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CC_MAVENIR_DATES } from '@constants/queryKeys';

export const useQueryCcMavenirDates = (params?: TMavenirDTO): {
	datesMavenirOptions: Date[];
	isLoadingMavenirDatesOptions: boolean;
} => {
	const {
		nodes,
		vendor,
		version,
		type,
	} = params || {};

	const {
		data: datesMavenirOptions,
		isFetching: isFetchingMavenirDatesOptions,
		isLoading: isLoadingMavenirDatesOptions,
	} = useQuery<Array<string>, Date[]>({
		queryKey: [
			CC_MAVENIR_DATES,
			{
				version,
				vendor,
				type,
				nodes,
			},
		],
		queryFn: extractQueryParams(getCCMavenirDates),
		select: (data: string[]) => data.map((date) => parseStringDate(date)),
		enabled: [!!vendor, vendor === EVendorsValues.mavenir, !!type, !!version, !!nodes?.length],
		...refetchOptions,
	});

	return {
		datesMavenirOptions: datesMavenirOptions || [],
		isLoadingMavenirDatesOptions: isLoadingMavenirDatesOptions && isFetchingMavenirDatesOptions,
	};
};
